export default "__VITE_ASSET__CenMDpqq__"